module.exports = {
  pathPrefix: "/ddj/quiz-silvester/",
  origin: "https://data.wdr.de",
  // pathPrefix: "/",
  // origin: "https://quiz-silvester.netlify.app",
};
